import gql from 'graphql-tag';

export class DsrFragments {
  static directory = gql`
    fragment dsrDirectoryFragment on DsrDirectory {
      id
      title
      directory
      createdAt
      updatedAt
      deletedAt
      user {
        fullName
      }
      updatedBy {
        fullName
      }
    }
  `;

  static resource = gql`
    fragment dsrResourceFragment on DsrResource {
      id
      user {
        fullName
        id
      }
      updatedBy {
        fullName
      }
      createdAt
      updatedAt
      title
      contentId
      directory
      resourceType
      access {
        readAccess
        writeAccess
      }
      statistics {
        useCount
        lastUsed
      }
      tagIds
      linkedTemplatesCount
    }
  `;
}
